/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import DevicePacketsDirective from './device-packets.directive';

export default angular.module('tektelic.devicePackets', [])
    .directive('tkDevicePackets', DevicePacketsDirective)
    .name;



// WEBPACK FOOTER //
// ./src/app/packets/index.js